export default __webpack_public_path__ + "static/media/slide2.61508ea8.jpeg";